import { RedirectToSignIn } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';
import './SignIn.css';

const SignInPage = () => {
    const [params] = useSearchParams();
    const redirect = params.get('redirect_url') || '';
    const safe = redirect.startsWith('/connect') && !redirect.startsWith('//') ? redirect : '/content';

    return (
        <div className="signin-container">
            <RedirectToSignIn signInForceRedirectUrl={safe} />
        </div>
    );
};

export default SignInPage;
